var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],class:_vm.classes},_vm._l((_vm.blogs),function(item){return _c('BlogItem',{key:item._uid,attrs:{"blok":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }